import { render, staticRenderFns } from "./v4_mobile.vue?vue&type=template&id=4976c673&"
import script from "./v4_mobile.vue?vue&type=script&lang=js&"
export * from "./v4_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports